module.exports = __webpack_public_path__ + "img/logoFPO.18a04df7.png";